"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RadioField = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _formik = require("formik");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Label = require("../primitive/Label");
var _ErrorMessage = _interopRequireDefault(require("./ErrorMessage"));
var _theme = require("../../constants/theme");
var _createBorderCss = _interopRequireDefault(require("../../utils/createBorderCss"));
var _excluded = ["children", "error"],
  _excluded2 = ["name", "validate"];
var Radio = function Radio(_ref) {
  var children = _ref.children,
    error = _ref.error,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Container, {
    hasError: !!error
  }, /*#__PURE__*/_react["default"].createElement(HiddenRadio, Object.assign({}, props, {
    type: "radio"
  })), /*#__PURE__*/_react["default"].createElement(Checkmark, {
    hasError: !!error
  }), /*#__PURE__*/_react["default"].createElement(StyledLabel, {
    htmlFor: props.id
  }, children)), error && /*#__PURE__*/_react["default"].createElement(_ErrorMessage["default"], null, error));
};
var RadioField = exports.RadioField = function RadioField(_ref2) {
  var name = _ref2.name,
    validate = _ref2.validate,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: name,
    validate: validate
  }, function (_ref3) {
    var field = _ref3.field,
      _ref3$form = _ref3.form,
      errors = _ref3$form.errors,
      touched = _ref3$form.touched;
    return /*#__PURE__*/_react["default"].createElement(Radio, Object.assign({
      error: touched[field.name] && errors[field.name] ? (0, _formik.getIn)(errors, field.name) : undefined,
      checked: props.id === field.value
    }, props, field, {
      value: props.id
    }));
  });
};
var _default = exports["default"] = Radio;
var HiddenRadio = _styledComponents["default"].input.attrs(function () {
  return {
    type: 'radio'
  };
}).withConfig({
  displayName: "Radio__HiddenRadio",
  componentId: "sc-xrollf-0"
})(["position:absolute;opacity:0;"]);
var StyledLabel = (0, _styledComponents["default"])(_Label.Label).attrs(function () {
  return {
    variant: 'regular'
  };
}).withConfig({
  displayName: "Radio__StyledLabel",
  componentId: "sc-xrollf-1"
})(["font-weight:400;", ":disabled ~ &{color:", ";}"], HiddenRadio, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.neutral['30'];
});
var Checkmark = _styledComponents["default"].span.withConfig({
  displayName: "Radio__Checkmark",
  componentId: "sc-xrollf-2"
})(["position:absolute;top:0;left:0;height:25px;width:25px;background-color:", ";border-radius:50%;", ";--border-color:", ";::after{top:6px;left:6px;width:13px;height:13px;border-radius:50%;background:white;content:'';position:absolute;display:none;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.neutral['0'];
}, (0, _createBorderCss["default"])('2px'), function (_ref6) {
  var theme = _ref6.theme,
    hasError = _ref6.hasError;
  return !hasError ? theme.colors.neutral['20'] : theme.colors.negative['60'];
});
var Container = _styledComponents["default"].label.withConfig({
  displayName: "Radio__Container",
  componentId: "sc-xrollf-3"
})(["display:flex;position:relative;padding-left:35px;font-size:22px;user-select:none;width:fit-content;height:25px;", ":hover + ", "{::after{display:block;background:", ";}}", ":focus + ", "{--border-color:", ";}", ":checked + ", "{::after{display:block;background:", ";}}", ":disabled + ", "{--border-color:", ";cursor:not-allowed;}", ":disabled:checked + ", "{::after{background:", ";}}", ":hover:disabled:not(:checked) + ", "{::after{display:none;}}"], HiddenRadio, Checkmark, function (_ref7) {
  var theme = _ref7.theme;
  return (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.input, -3);
}, HiddenRadio, Checkmark, function (_ref8) {
  var theme = _ref8.theme,
    hasError = _ref8.hasError;
  return !hasError ? (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.input) : theme.colors.negative['60'];
}, HiddenRadio, Checkmark, function (_ref9) {
  var theme = _ref9.theme,
    hasError = _ref9.hasError;
  return !hasError ? (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.input) : theme.colors.negative['60'];
}, HiddenRadio, Checkmark, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.neutral['30'];
}, HiddenRadio, Checkmark, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.neutral['30'];
}, HiddenRadio, Checkmark);
//# sourceMappingURL=Radio.js.map